module.exports = __webpack_public_path__ + "media/img/corporate/engaging-185f68a0097400d4cf3878850e27b6a6.png";